"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingsRequestBuilder = void 0;
class ListingsRequestBuilder {
    constructor() {
        this.request = {
            currencyCode: 'GBP',
            facetSpecs: [],
            filter: {},
        };
    }
    currency(code) {
        this.request.currencyCode = code;
        return this;
    }
    offset(offset) {
        this.request.offset = offset;
        return this;
    }
    pageSize(size) {
        this.request.pageSize = size;
        return this;
    }
    searchTerm(term) {
        this.request.searchTerm = term;
        return this;
    }
    facetSpecs(facetSpecs) {
        if (this.request.facetSpecs.length) {
            throw new Error('facet specs already set on the request');
        }
        this.request.facetSpecs = facetSpecs;
        return this;
    }
    filter(filter) {
        if (this.request.filter && Object.keys(this.request.filter).length > 0) {
            throw new Error('a filter is already set on the request');
        }
        this.request.filter = filter;
        return this;
    }
    pageCategories(pageCategories) {
        this.request.pageCategories = pageCategories;
        return this;
    }
    sortBy(key, descending) {
        this.request.sortBy = key ? `${key}${descending ? ' desc' : ''}` : '';
        return this;
    }
    build() {
        return Object.assign({}, this.request);
    }
}
exports.ListingsRequestBuilder = ListingsRequestBuilder;
